import PropTypes from 'prop-types';
import {forwardRef} from 'react';

const TaskWrapper = forwardRef(
  ({disableDrag, onDrag, isDragging, isSelected, onContextMenu, onClick, children}, ref) => (
    <div
      ref={(el) => {
        if (ref) ref.current = el;
        if (!disableDrag && onDrag) onDrag(el);
      }}
      className={`task ${isSelected && 'selected'} ${isDragging && 'dragging'}`}
      onContextMenu={onContextMenu}
      onMouseDown={() => {
        if (onClick) onClick();
      }}
    >
      {children}
    </div>
  ),
);

TaskWrapper.propTypes = {
  disableDrag: PropTypes.bool,
  isDragging: PropTypes.bool,
  isSelected: PropTypes.bool,
  onDrag: PropTypes.func,
  onContextMenu: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

TaskWrapper.defaultProps = {
  disableDrag: true,
  isSelected: false,
  isDragging: false,
  onDrag: null,
  onContextMenu: null,
  onClick: null,
  children: null,
};

export default TaskWrapper;
